import { render } from "./WithIcon.vue?vue&type=template&id=2ce40b56"
import script from "./WithIcon.vue?vue&type=script&lang=ts"
export * from "./WithIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script